import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=0c7fd9dd&scoped=true"
import script from "./button-group.vue?vue&type=script&lang=js"
export * from "./button-group.vue?vue&type=script&lang=js"
import style0 from "./button-group.vue?vue&type=style&index=0&id=0c7fd9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fd9dd",
  null
  
)

export default component.exports